"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicReviewGroup = exports.getPublicReviewGroups = exports.deleteReviewGroupRelation = exports.postReviewGroupRelation = exports.putReviewGroupOrganization = exports.putReviewGroupAccessibility = exports.deleteReviewGroupPermission = exports.postReviewGroupPermission = exports.putReviewGroupAction = exports.postReviewGroup = exports.putReviewGroup = exports.getReviewGroup = exports.getReviewGroups = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var reviewGroupsAuthorizedPath = root_1.pimAuthorized + '/reviewGroups/';
var reviewGroupsPublicPath = root_1.pimPublic + '/reviewGroups/';

var getReviewGroups = function getReviewGroups(authentication, queryParameters) {
  return common_1.get(authentication, reviewGroupsAuthorizedPath, queryParameters);
};

exports.getReviewGroups = getReviewGroups;

var getReviewGroup = function getReviewGroup(authentication, id) {
  return common_1.get(authentication, reviewGroupsAuthorizedPath + id);
};

exports.getReviewGroup = getReviewGroup;

var putReviewGroup = function putReviewGroup(authentication, reviewGroup) {
  return common_1.put(authentication, reviewGroupsAuthorizedPath + reviewGroup.id, reviewGroup);
};

exports.putReviewGroup = putReviewGroup;

var postReviewGroup = function postReviewGroup(authentication, reviewGroup) {
  return common_1.post(authentication, reviewGroupsAuthorizedPath, reviewGroup);
};

exports.postReviewGroup = postReviewGroup;

var putReviewGroupAction = function putReviewGroupAction(authentication, id, action, data) {
  return common_1.putSub(authentication, reviewGroupsAuthorizedPath, id, action, data);
};

exports.putReviewGroupAction = putReviewGroupAction;

var postReviewGroupPermission = function postReviewGroupPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, reviewGroupsAuthorizedPath, id, permission);
};

exports.postReviewGroupPermission = postReviewGroupPermission;

var deleteReviewGroupPermission = function deleteReviewGroupPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, reviewGroupsAuthorizedPath, id, permissionId);
};

exports.deleteReviewGroupPermission = deleteReviewGroupPermission;

var putReviewGroupAccessibility = function putReviewGroupAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, reviewGroupsAuthorizedPath, id, accessibility);
};

exports.putReviewGroupAccessibility = putReviewGroupAccessibility;

var putReviewGroupOrganization = function putReviewGroupOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, reviewGroupsAuthorizedPath, id, accessibility);
};

exports.putReviewGroupOrganization = putReviewGroupOrganization;

var postReviewGroupRelation = function postReviewGroupRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, reviewGroupsAuthorizedPath, id, relation);
};

exports.postReviewGroupRelation = postReviewGroupRelation;

var deleteReviewGroupRelation = function deleteReviewGroupRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, reviewGroupsAuthorizedPath, id, relationId);
};

exports.deleteReviewGroupRelation = deleteReviewGroupRelation;

var getPublicReviewGroups = function getPublicReviewGroups(authentication, queryParameters) {
  return common_1.get(authentication, reviewGroupsPublicPath, queryParameters);
};

exports.getPublicReviewGroups = getPublicReviewGroups;

var getPublicReviewGroup = function getPublicReviewGroup(authentication, id) {
  return common_1.get(authentication, reviewGroupsPublicPath + id);
};

exports.getPublicReviewGroup = getPublicReviewGroup;